export default function togglePageScrollLock({
  method,
  withOffset,
}: {
  method: "add" | "remove";
  withOffset?: boolean;
}) {
  const html = document.documentElement;
  const body = document.body;

  const scrollTop = document.documentElement.scrollTop;

  if (html && body) {
    [html, body].forEach((el) => el.classList[method]("disable-page-scroll"));

    if (withOffset) {
      body.style.paddingTop = method === "add" ? scrollTop + "px" : "0px";
    }
  }
}
/**
 * It watches body element and resolves once class "disable-page-scroll" is removed
 */
export function observeScrollToUnlock() {
  return new Promise<void>((resolve) => {
    const el = document.body;
    const isScrollUnlocked = !el.classList.contains("disable-page-scroll");

    if (isScrollUnlocked) {
      resolve();
      return;
    }

    const observer = new MutationObserver((mutationRecords, observer) => {
      for (const mutation of mutationRecords) {
        if (mutation.type !== "attributes") {
          return;
        }

        const el = mutation.target as HTMLElement;
        if (!el.classList.contains("disable-page-scroll")) {
          observer.disconnect();
          resolve();
        }
      }
    });

    observer.observe(document.body, {
      attributeFilter: ["class"],
      attributes: true,
      childList: false,
      subtree: false,
    });
  });
}
